var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"white"}}),_c('path',{attrs:{"d":"M19 17H7V19H19V17Z","fill":"#F8B500"}}),_c('path',{attrs:{"d":"M19 7H7V14H19V7Z","fill":"#F8B500"}})])}
var staticRenderFns = []

export { render, staticRenderFns }